import { StructExamUserData } from "@/lib/model/exam/exam";

export default class ExamCreateForm extends StructExamUserData {
  userId = 0;
  companyId = 0;
}

export class ExamUpdateForm extends ExamCreateForm {
  examId = 0;
}
